import React from 'react';
import { reduxForm, Field, formValueSelector } from 'redux-form';
import { connect } from 'react-redux';

import Form from 'forms/Form';
import InputField from 'forms/InputField';
import FormButton from 'forms/FormButton';
import Box from 'common/Box';
import SquareRadioButton from '../../forms/SquareRadioButton';
import ReduxFormSelect from '../../forms/ReduxFormSelect';
import { statesOptions } from 'app_constants/states';
import Warning from 'notifications/Warning';
import { Warning as NotConnectedWarning } from 'notifications/Warning';
import { error } from 'notifications/actions';

import styles from './index.module.css';

const lineSelectOptions = [1, 2, 3, 4, 5].map(n => ({ label: n, value: n }) );

const getShippingComment = (shippingMethod) => {
  let comment = '';
  switch(shippingMethod) {
    case 'regular':
      comment = `3 - 5 Business Days`;
      break;
    case 'twoday': 
      comment = `2 Business Days`;
      break;
    case 'overnight':
      comment = `1 Business Day`;
      break;
    default: 
      comment = `3 - 5 Business Days`;
  }

  return comment
}

class OrderSimForm extends React.Component {

  state = {
    showRequiredInfoMessage: false
  }

  handleClickSubmit = values => {
    const { error } = this.props
    if (error && error.showRequiredInfoMessage) {
      this.setState({ showRequiredInfoMessage: true }, () => {
        setTimeout(() => {
          this.setState({ showRequiredInfoMessage: false });
        }, 15000)
      });
    }
  }

  render() {
    const { shippingMethod, error } = this.props;
    const { showRequiredInfoMessage } = this.state;
    
    return (
        <Box>
          <Form {...this.props} noSubmitButton>
            <h2>SIM type</h2>
            <div className={styles.groupNoMargin}>
              <div className={styles.columnMobile}>
                <Field name="type" component={SquareRadioButton} label="Wing (AT&T)" radioValue="att" />
              </div>
              <div className={styles.columnMobile}>
                <Field name="type" component={SquareRadioButton} label="Wing (Verizon SIM)" radioValue="verizon"/>
              </div>
              <div className={styles.columnMobile}>
                <Field name="type" component={SquareRadioButton} label="Wing (T-Mobile)" radioValue="tmobile" />
              </div>
            </div>
            <Field name="quantity" component={ReduxFormSelect} label="Quantity" options={lineSelectOptions} placeholder="Select" />
            <h2>Shipping Details</h2>
            <div className={styles.lineWrapper}>
              <Field name="address1" component={InputField} label="Street address" placeholder="555 Broadway St" required />
            </div>
            <div className={styles.lineWrapper}>
              <Field name="address2" component={InputField} label="Street address 2" />
            </div>
            <div className={styles.lineWrapper}>
              <Field name="city" component={InputField} label="City" placeholder="New York" required />
            </div>
            <div className={styles.group}>
              <div className={styles.column}>
                <Field name="state" component={ReduxFormSelect} label="State" options={statesOptions} placeholder="Select" required/>
              </div>
              <div className={styles.column}>
                <Field name="zip_code" component={InputField} label="Zip" placeholder="10001" required/>
              </div>
            </div>
            <div className={styles.lineWrapper}>
              <Field name="phone" component={InputField} label="Phone Number" required />
            </div>
            <h2>Shipping Method</h2>
            <div className={styles.groupNoMargin}>
              <div className={styles.columnMobile}>
                <Field name="shippingMethod" component={SquareRadioButton} label="Regular" radioValue="regular" />
              </div>
              <div className={styles.columnMobile}>
                <Field name="shippingMethod" component={SquareRadioButton} label="Two-day" radioValue="twoday"/>
              </div>
              <div className={styles.columnMobile}>
                <Field name="shippingMethod" component={SquareRadioButton} label="Overnight" radioValue="overnight"/>
              </div>
            </div>
            <div className={styles.shippingMethod}>
              { getShippingComment(shippingMethod) }
            </div>
            <Warning name="orderSim" />
            { showRequiredInfoMessage && error && error.showRequiredInfoMessage &&
              <NotConnectedWarning message="Please fill all required fields" />
            }
            <FormButton className={styles.submit} onClick={this.handleClickSubmit}>
              Continue
            </FormButton>
          </Form>
        </Box>
    )
  }
}

const validate = (values) => {
  const err = {};
  const required = ['type', 'state', 'zip_code', 'shippingMethod', 'quantity', 'address1', 'phone', 'city'];

  for (const field of required) {
    if (!values[field]) {
      err[field] = 'Required';
      err._error = { showRequiredInfoMessage : true };
    }
  }

  if (values.zip_code && values.zip_code.length !==  5) {
    err.zip_code = 'Invalid zip code';
  }

  return err;
}

const ReduxFormOrderSimDetails = reduxForm({
  form: 'orderSimDetails',
  validate,
  initialValues: {
    type: 'att',
    shippingMethod: 'regular',
    quantity: 1,
  }
})(OrderSimForm);

const mapStateToProps = state => {
  const selector = formValueSelector('orderSimDetails')
  const shippingMethod  = selector(state, 'shippingMethod');
  
  return {
    shippingMethod,
  }
}

const mapDispatchToProps = {
  errorNoty: error
}

export default connect(mapStateToProps, mapDispatchToProps)(ReduxFormOrderSimDetails);